import React from "react";
import PropTypes from "prop-types";

import { HeaderFooter, Item, Separator } from ".";

const Lists = props => {
	const { scopePicked } = props;
	let content = null;

	switch (scopePicked) {
		case "header":
		case "footer":
			content = <HeaderFooter scope={scopePicked} />;
			break;
		case "item":
			content = <Item {...props} />;
			break;
		case "separator":
			content = <Separator />;
			break;
		default:
			break;
	}

	return content;
};

Lists.propTypes = {
	checkForEmptyValue: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	scopePicked: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Lists;
